/**
 * Teams OAuth "Destination" toggle — send to a team Channel vs a group Chat.
 * Two-item SegmentedControl with icons; tokens only.
 */
import { Hash, MessagesSquare } from 'lucide-react';
import { SegmentedControl } from '@vnetwork/ui/primitives';

export type TeamsTargetType = 'channel' | 'chat';

export interface TeamsDestinationToggleProps {
  value: TeamsTargetType;
  onChange: (target: TeamsTargetType) => void;
}

const DESTINATION_ITEMS = [
  { value: 'channel', label: 'Channel', icon: <Hash size={13} /> },
  { value: 'chat', label: 'Chat', icon: <MessagesSquare size={13} /> },
];

export function TeamsDestinationToggle({ value, onChange }: TeamsDestinationToggleProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--vn-space-2)', flexWrap: 'wrap' }}>
      <span style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)' }}>
        Send to:
      </span>
      <SegmentedControl
        size="sm"
        items={DESTINATION_ITEMS}
        value={value}
        onValueChange={(v) => onChange(v as TeamsTargetType)}
      />
    </div>
  );
}
